<h4>{{ title }}</h4>
<div
  class="list"
  *ngFor="let block of data; let i = index"
  [class.comparison]="i > 0"
>
  <h4>{{ block.title }}</h4>
  <div
    *ngFor="let elem of block.list | slice : 0 : 5; let i = index"
    class="elem"
  >
    <p class="row">
      <span class="position">{{ i + 1 }}. </span>
      <span class="name">{{ elem[labelKey] | translate }}</span>
      <span class="value">
        {{
          elem[valueKey]
            ? (elem[valueKey] | hideZeroValues : '1.0-0')
            : (elem[valueKey] | hideZeroValues)
        }}
        <span>{{ elem.unit }}</span>
      </span>
    </p>
  </div>
</div>
<a class="btn-detail" *ngIf="showViewFullTable" (click)="openPopup()">{{
  'View full table' | translate
}}</a>
